import Cart from "./../cart/Cart";

document.addEventListener("DOMContentLoaded", () => {
    let cart = new Cart();
    let addToCartButton = document.querySelectorAll(".js-add-to-cart");
    if (addToCartButton.length > 0) {
        addToCartButton.forEach((acb) => {
            acb.addEventListener("click", cart.addToCartButton);
        });
    }
});
